/**
 * Управление языками и локализацией интерфейса
 */

// Получаем состояние
var getCurrentLang = function() {
  return window.SEARCH_STATE ? window.SEARCH_STATE.getCurrentLang() : 'en';
};

var setCurrentLang = function(lang) {
  if (window.SEARCH_STATE) {
    window.SEARCH_STATE.setCurrentLang(lang);
  }
};

var getNothingFoundText = function() {
  return window.SEARCH_STATE ? window.SEARCH_STATE.getNothingFoundText() : 'Nothing found';
};

var setNothingFoundText = function(text) {
  if (window.SEARCH_STATE) {
    window.SEARCH_STATE.setNothingFoundText(text);
  }
};

// Функция для обновления текстов интерфейса при смене языка
function updateInterfaceTexts(lang) {
  if (typeof LANG_TEXTS === 'undefined' || !LANG_TEXTS[lang]) {
    console.error('LANG_TEXTS not available for language:', lang);
    return;
  }
  
  var texts = LANG_TEXTS[lang];
  
  // Обновляем nothingFoundText
  setNothingFoundText(texts.nothing_found);
  document.body.setAttribute('data-nothing-found', texts.nothing_found);
  
  // Обновляем placeholder поля поиска
  var searchInput = document.getElementById('search');
  if (searchInput) {
    searchInput.placeholder = texts.placeholder;
  }
  
  // Обновляем заголовок
  var headingLink = document.querySelector('#heading a');
  if (headingLink) {
    headingLink.textContent = texts.heading;
    headingLink.href = '/' + lang + '/';
  }

  // Обновляем ссылку на гайд в шапке
  var guideLink = document.querySelector('.langs-book-icon');
  if (guideLink) {
    guideLink.href = '/' + lang + '/guide/';
    guideLink.title = texts.tab_help || 'Guide';
  }

  // Обновляем кнопку домой в шапке (для страницы гайда)
  var homeLink = document.querySelector('.langs-home-button');
  if (homeLink) {
    homeLink.href = '/' + lang + '/';
    homeLink.title = texts.tab_home || 'Home';
  }

  // Обновляем title страницы
  document.title = texts.title;
  
  // Обновляем лейбл режима поиска
  var searchTypeLabel = document.querySelector('.search-type-label span');
  if (searchTypeLabel) {
    searchTypeLabel.textContent = texts.search_type_label;
  }
  
  // Обновляем кнопку поиска title
  var searchButton = document.querySelector('.search-button');
  if (searchButton) {
    // searchButton.title = texts.submit; // Убрали тултип по просьбе пользователя
  }

  // Обновляем подсказку режима поиска
  var searchModeToggle = document.getElementById('search-mode-toggle');
  if (searchModeToggle) {
    var mode = searchModeToggle.getAttribute('data-mode');
    var tooltip = (mode === 'smart') ? (texts.search_type_smart_desc || 'Smart') : (texts.search_type_classical_desc || 'Classical');
    searchModeToggle.title = tooltip;
    var modeLabel = searchModeToggle.querySelector('.search-mode-label');
    if (modeLabel && texts.search_mode_label) {
      modeLabel.textContent = texts.search_mode_label;
    }
  }
  
  // Обновляем лейблы типов поиска
  var exactLabel = document.querySelector('label[for="search-type-exact"]');
  if (exactLabel) {
    exactLabel.textContent = texts.exact_label;
  }
  
  var defaultLabel = document.querySelector('label[for="search-type-default"]');
  if (defaultLabel) {
    var labelText = texts.default_label;
    defaultLabel.innerHTML = labelText.replace(/\*/g, '<span class="search-pattern-star">*</span>');
  }
  
  var broadLabel = document.querySelector('label[for="search-type-broad"]');
  if (broadLabel) {
    var labelText = texts.wide_label;
    broadLabel.innerHTML = labelText.replace(/\*/g, '<span class="search-pattern-star">*</span>');
  }
  
  var descLabel = document.querySelector('label[for="search-type-description"]');
  if (descLabel) {
    descLabel.textContent = texts.description_label;
  }
  
  // Обновляем модалку с типами поиска
  var modalTitle = document.querySelector('.search-type-modal-title');
  if (modalTitle) {
    modalTitle.textContent = texts.search_types_title;
  }
  
  // Обновляем текст модалки (переключаем блоки по атрибуту data-lang-content)
  var modalContainer = document.querySelector('.search-type-modal-text');
  if (modalContainer) {
    var langContents = modalContainer.querySelectorAll('.search-type-content');
    langContents.forEach(function(content) {
      if (content.getAttribute('data-lang-content') === lang) {
        content.style.display = 'block';
      } else {
        content.style.display = 'none';
      }
    });
  }
  
  // Обновляем тексты истории поиска
  var historyTitle = document.getElementById('search-history-modal-title');
  if (historyTitle && texts.history_title) {
    var subtitle = texts.history_subtitle || '';
    var tooltipText = texts.history_info_tooltip ? texts.history_info_tooltip.replace(/"/g, '&quot;').replace(/'/g, '&#39;') : '';
    var infoIcon = texts.history_info_tooltip ? '<span class="search-history-info-icon" onclick="openDictDescTooltip(event, \'' + tooltipText + '\')">?</span>' : '';
    historyTitle.innerHTML = texts.history_title + ' <span class="search-history-subtitle">' + subtitle + '</span>' + infoIcon;
  }
  
  var historyClearBtn = document.getElementById('search-history-clear-btn');
  if (historyClearBtn && texts.history_clear) {
    historyClearBtn.textContent = texts.history_clear;
  }
  
  var historyDisableText = document.getElementById('search-history-disable-text');
  if (historyDisableText && texts.history_disable) {
    historyDisableText.textContent = texts.history_disable;
  }
  
  // Обновляем названия самих табов (включая активную вкладку)
  var historyTabBtn = document.querySelector('.search-modal-tab[data-tab="history"]');
  if (historyTabBtn && texts.tab_history) {
    historyTabBtn.textContent = texts.tab_history;
  }
  
  var settingsTabBtn = document.querySelector('.search-modal-tab[data-tab="settings"]');
  if (settingsTabBtn && texts.tab_settings) {
    settingsTabBtn.textContent = texts.tab_settings;
  }

  var appearanceTabBtn = document.querySelector('.search-modal-tab[data-tab="appearance"]');
  if (appearanceTabBtn && texts.tab_appearance) {
    appearanceTabBtn.textContent = texts.tab_appearance;
  }
  
  // Также обновляем активную вкладку явно (на случай, если селектор не сработал)
  var activeTab = document.querySelector('.search-modal-tab.active');
  if (activeTab) {
    var tabType = activeTab.getAttribute('data-tab');
    if (tabType === 'history' && texts.tab_history) {
      activeTab.textContent = texts.tab_history;
    } else if (tabType === 'settings' && texts.tab_settings) {
      activeTab.textContent = texts.tab_settings;
    } else if (tabType === 'appearance' && texts.tab_appearance) {
      activeTab.textContent = texts.tab_appearance;
    }
  }
  
  var historyButton = document.getElementById('search-history-button');
  if (historyButton && texts.history_title) {
    historyButton.title = texts.history_title;
  }

  // Обновляем заголовок панели цепочек
  var chainPanelTitle = document.getElementById('chain-panel-title-text');
  if (chainPanelTitle && texts.chain_panel_title) {
    chainPanelTitle.textContent = texts.chain_panel_title;
  }
  var chainPanel = document.getElementById('chain-panel');
  if (chainPanel && texts.chain_panel_title) {
    chainPanel.setAttribute('aria-label', texts.chain_panel_title);
  }

  // Обновляем заголовок и кнопку в выпадающем списке истории
  var historyDropdownTitle = document.querySelector('.search-history-dropdown-title');
  if (historyDropdownTitle && texts.history_title) {
    historyDropdownTitle.textContent = texts.history_title;
  }
  var historyDropdownClear = document.querySelector('#search-history-dropdown-clear .clear-text');
  if (historyDropdownClear && texts.history_clear) {
    historyDropdownClear.textContent = texts.history_clear;
  }

  // ��бновляем за��оловок настроек и dashboard summary label
  var settingsTitle = document.getElementById('search-settings-modal-title');
  if (settingsTitle && texts.settings_title) {
    settingsTitle.textContent = texts.settings_title;
  }
  var summaryLabel = document.getElementById('summary-dicts-label');
  if (summaryLabel && texts.settings_summary_dicts) {
    summaryLabel.textContent = texts.settings_summary_dicts;
  }

  // Обновляем настройки режима клика
  var clickTitle = document.getElementById('settings-click-search-title');
  if (clickTitle && texts.settings_click_mode) {
    var tooltipText = texts.settings_click_mode_info_tooltip ? texts.settings_click_mode_info_tooltip.replace(/"/g, '&quot;').replace(/'/g, '&#39;') : '';
    var infoIcon = texts.settings_click_mode_info_tooltip ? '<span class="search-history-info-icon" onclick="openDictDescTooltip(event, \'' + tooltipText + '\')">?</span>' : '';
    clickTitle.innerHTML = texts.settings_click_mode + (infoIcon ? ' ' + infoIcon : '');
  }
  var clickOptTwo = document.getElementById('click-mode-two');
  if (clickOptTwo && texts.settings_click_two) {
    clickOptTwo.textContent = texts.settings_click_two;
  }
  var clickOptOne = document.getElementById('click-mode-one');
  if (clickOptOne && texts.settings_click_one) {
    clickOptOne.textContent = texts.settings_click_one;
  }

  // Обновляем вкладку Оформление
  var appearanceTab = document.getElementById('tab-appearance');
  if (appearanceTab) {
    // Заголовки разделов
    var titles = appearanceTab.querySelectorAll('.search-history-modal-title');
    if (titles.length >= 1 && texts.appearance_mode_title) titles[0].textContent = texts.appearance_mode_title;
    if (titles.length >= 2 && texts.appearance_profile_title) titles[1].textContent = texts.appearance_profile_title;

    // Режимы темы
    var lightLabel = appearanceTab.querySelector('label[for="theme-light"]');
    if (lightLabel && texts.appearance_theme_light) lightLabel.textContent = texts.appearance_theme_light;
    var autoLabel = appearanceTab.querySelector('label[for="theme-auto"]');
    if (autoLabel && texts.appearance_theme_auto) autoLabel.textContent = texts.appearance_theme_auto;
    var darkLabel = appearanceTab.querySelector('label[for="theme-dark"]');
    if (darkLabel && texts.appearance_theme_dark) darkLabel.textContent = texts.appearance_theme_dark;

    // Профили - динамически получаем все профили из DOM
    var profileCards = appearanceTab.querySelectorAll('.color-profile-card[data-profile]');
    profileCards.forEach(function(card) {
      var profileId = card.getAttribute('data-profile');
      if (!profileId) return;
      
      var nameElem = card.querySelector('.profile-name');
      var descElem = card.querySelector('.profile-desc');
      
      // Используем переводы из LANG_TEXTS, если они есть
      var nameKey = 'appearance_profile_' + profileId + '_name';
      var descKey = 'appearance_profile_' + profileId + '_desc';
      
      if (nameElem && texts[nameKey]) {
        nameElem.textContent = texts[nameKey];
      }
      if (descElem && texts[descKey]) {
        descElem.textContent = texts[descKey];
      }
    });
  }

  // Обновляем заголовки языковых групп в настройках
  var settingsTab = document.getElementById('tab-settings');
  if (settingsTab) {
    var langGroups = settingsTab.querySelectorAll('.language-group');
    langGroups.forEach(function(group) {
      var langCode = group.getAttribute('data-lang-group');
      if (langCode) {
        var langLabel = group.querySelector('.lang-name');
        if (langLabel && texts['lang_' + langCode]) {
          langLabel.textContent = texts['lang_' + langCode];
        }
      }
    });
  }

  // Обновляем заголовки групп внутри языков
  if (settingsTab) {
    var groupTitles = settingsTab.querySelectorAll('.group-title');
    groupTitles.forEach(function(title) {
      var checkbox = document.getElementById(title.getAttribute('for'));
      if (checkbox) {
        var groupType = checkbox.getAttribute('data-group');
        if (groupType === 'scn' && texts.settings_group_scn) {
          title.textContent = texts.settings_group_scn;
        } else if (groupType === 'other' && texts.settings_group_other) {
          title.textContent = texts.settings_group_other;
        }
      }
    });
  }

  // Обновляем модалку капчи
  var captchaTitle = document.querySelector('.captcha-modal-title');
  if (captchaTitle && texts.captcha_title) {
    captchaTitle.textContent = texts.captcha_title;
  }
  var captchaDesc = document.querySelector('.captcha-modal-desc');
  if (captchaDesc && texts.captcha_desc) {
    captchaDesc.textContent = texts.captcha_desc;
  }

  // Обновляем ссылку в футере
  var footerBrowseLink = document.getElementById('footer-browse-link');
  if (footerBrowseLink) {
    var browseTexts = {
      'ru': 'Архив терминов',
      'en': 'Terms Archive',
      'de': 'Begriff-Archiv',
      'fr': 'Archives des termes'
    };
    footerBrowseLink.textContent = browseTexts[lang] || 'Terms Archive';
    footerBrowseLink.href = '/' + lang + '/browse/';
  }

  // Android app landing link in the footer (SSR text is per-language; a client-side
  // language switch must re-translate it too, else it keeps the previous language)
  var footerAppLink = document.getElementById('footer-app-link');
  if (footerAppLink) {
    var appTexts = {
      'ru': 'Приложение для Android',
      'en': 'Android app',
      'de': 'Android-App',
      'fr': 'Application Android'
    };
    footerAppLink.textContent = appTexts[lang] || 'Android app';
    footerAppLink.href = '/' + lang + '/app/';
  }
}

// Функция для переключения языковой вкладки
function switchLanguageTab(newLang) {
  // Обновляем активную вкладку
  var langLinks = document.querySelectorAll('#langs a:not(.langs-book-icon)');
  langLinks.forEach(function(link) {
    link.classList.remove('active');
    if (link.getAttribute('href') === '/' + newLang + '/') {
      link.classList.add('active');
    }
  });
  
  // Обновляем текущий язык
  setCurrentLang(newLang);
  
  // Сохраняем язык в cookies
  if (window.SEARCH_UTILS && window.SEARCH_UTILS.saveLanguage) {
    window.SEARCH_UTILS.saveLanguage(newLang);
  }

  // Обновляем тексты интерфейса
  updateInterfaceTexts(newLang);
  
  if (window.updateSearchFormBorderRadius && typeof window.updateSearchFormBorderRadius === 'function') {
    window.updateSearchFormBorderRadius();
  }
}

// Функция для определения языка по символам в строке поиска (логика как в PHP)
function detectLanguageFromSearch(searchTerm) {
  var currentLang = getCurrentLang();
  if (!['en', 'ru', 'de', 'fr'].includes(currentLang)) {
    currentLang = 'en';
  }
  
  var hiddenLangs = [];
  if (window.SEARCH_HISTORY && window.SEARCH_HISTORY.getHiddenLangs) {
    hiddenLangs = window.SEARCH_HISTORY.getHiddenLangs();
  }
  
  var hasCyrillic = /[а-яёА-ЯЁ]/.test(searchTerm);
  var hasGermanChars = /[äöüßÄÖÜ]/.test(searchTerm);
  var hasFrenchChars = /[àâæçèéêëîïôœùûÿÀÂÆÇÈÉÊËÎÏÔŒÙÛŸ]/.test(searchTerm);
  var hasLatin = /[a-zA-Z]/.test(searchTerm);

  // 1. Проверка на смешанный алфавит (Кириллица + Латиница)
  // Если в строке есть и русские, и любые латинские буквы (включая умлауты) — не переключаем.
  if (hasCyrillic && (hasLatin || hasGermanChars || hasFrenchChars)) {
    return null;
  }

  // 2. Проверка на конфликт внутри латинских диакритик (Немецкий + Французский)
  var signaturesFound = 0;
  if (hasCyrillic) signaturesFound++;
  if (hasGermanChars) signaturesFound++;
  if (hasFrenchChars) signaturesFound++;

  // Если признаков больше одного — это смешанный запрос, не переключаем.
  if (signaturesFound > 1) {
    return null;
  }

  var candidateLangs = [];
  function addCandidate(lang) {
    if (candidateLangs.indexOf(lang) === -1) {
      candidateLangs.push(lang);
    }
  }

  switch (currentLang) {
    case 'ru':
      if (hasFrenchChars && !hiddenLangs.includes('fr')) addCandidate('fr');
      if (hasGermanChars && !hiddenLangs.includes('de')) addCandidate('de');
      break;
    case 'en':
      if (hasCyrillic && !hiddenLangs.includes('ru')) addCandidate('ru');
      if (hasFrenchChars && !hiddenLangs.includes('fr')) addCandidate('fr');
      if (hasGermanChars && !hiddenLangs.includes('de')) addCandidate('de');
      break;
    case 'de':
      if (hasFrenchChars && !hiddenLangs.includes('fr')) addCandidate('fr');
      if (hasCyrillic && !hiddenLangs.includes('ru')) addCandidate('ru');
      break;
    case 'fr':
      if (hasCyrillic && !hiddenLangs.includes('ru')) addCandidate('ru');
      if (hasGermanChars && !hiddenLangs.includes('de')) addCandidate('de');
      break;
  }

  // Если совпала ровно одна цель — маршрутизируем.
  return candidateLangs.length === 1 ? candidateLangs[0] : null;
}

/**
 * Функция для предложения переключить язык, если поиск не дал результатов.
 * Более либеральная, чем detectLanguageFromSearch, но достаточно строгая,
 * чтобы не предлагать переключение из-за одной опечатки.
 */
function getSuggestedLanguage(searchTerm) {
  var currentLang = getCurrentLang();
  
  // Регулярные выражения для разных наборов символов
  var cyrillicRegex = /[а-яёА-ЯЁ]/g;
  var germanRegex = /[äöüßÄÖÜ]/g;
  var frenchRegex = /[àâæçèéêëîïôœùûÿÀÂÆÇÈÉÊËÎÏÔŒÙÛŸ]/g;
  var latinRegex = /[a-zA-Z]/g;

  // Считаем количество символов каждого типа
  var cyrillicCount = (searchTerm.match(cyrillicRegex) || []).length;
  var germanCount = (searchTerm.match(germanRegex) || []).length;
  var frenchCount = (searchTerm.match(frenchRegex) || []).length;
  var latinCount = (searchTerm.match(latinRegex) || []).length;

  // Общее количество алфавитных символов
  var totalAlpha = cyrillicCount + latinCount + germanCount + frenchCount;
  if (totalAlpha === 0) return null;

  // 1. Если преобладает кириллица (минимум 2/3) и мы не на русском — предлагаем русский
  if (cyrillicCount > 0 && currentLang !== 'ru') {
    if (cyrillicCount / totalAlpha >= 0.6) {
      return 'ru';
    }
  }

  // 2. Если есть специфические немецкие символы и мы не на немецком — предлагаем немецкий
  if (germanCount > 0 && currentLang !== 'de') {
    // Для диакритики достаточно даже одного символа, если нет конфликта с кириллицей
    if (cyrillicCount === 0) {
      return 'de';
    }
  }

  // 3. Если есть специфические французские символы и мы не на французском — предлагаем французский
  if (frenchCount > 0 && currentLang !== 'fr') {
    if (cyrillicCount === 0) {
      return 'fr';
    }
  }

  // Проверка на чистую латиницу (без умлаутов/акцентов)
  var isPureLatin = totalAlpha > 0 && totalAlpha === latinCount;

  // 4. Если только чистая латиница и мы на русском — предлагаем английский.
  // Для DE/FR подобное предложение не показываем: их интерфейсы уже латинские,
  // и «искать по-английски» только отвлекает пользователя.
  if (isPureLatin && currentLang === 'ru') {
    return 'en';
  }

  return null;
}

// Функция для загрузки intro контента с morphing-эффектом
function loadIntroContent(lang) {
  var container = document.getElementById('results-container');
  if (!container) {
    console.error('Results container not found');
    return;
  }
  
  var apiUrl = '/api/intro?lang=' + encodeURIComponent(lang);
  
  fetch(apiUrl)
    .then(function(response) {
      var contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        throw new Error('Response is not JSON. Content-Type: ' + contentType);
      }
      return response.json();
    })
    .then(function(data) {
      if (!data.success || !container) {
        console.error('Intro load failed:', data);
        return;
      }
      
      var prevTransition = container.style.transition;
      var prevMinHeight = container.style.minHeight;
      var prevOpacity = container.style.opacity;
      var currentHeight = container.offsetHeight;
      
      container.style.minHeight = currentHeight + 'px';
      container.style.transition = 'opacity 200ms ease';
      
      requestAnimationFrame(function() {
        container.style.opacity = '0';
        
        setTimeout(function() {
          container.innerHTML = data.intro;
          if (window.SLOVARY_REF_COLLAPSED && window.SLOVARY_REF_COLLAPSED.init) {
            window.SLOVARY_REF_COLLAPSED.init(container);
          }
          
          requestAnimationFrame(function() {
            container.style.opacity = '1';
            
            setTimeout(function() {
              container.style.minHeight = prevMinHeight || '';
              container.style.transition = prevTransition || '';
              container.style.opacity = prevOpacity || '';
            }, 220);
          });
        }, 210);
      });
    })
    .catch(function(error) {
      console.error('Error loading intro:', error);
    });
}

// Полная функция переключения языка (без перезагрузки)
function switchLanguage(newLang, searchTerm, searchType) {
  if (!['en', 'ru', 'de', 'fr'].includes(newLang)) {
    newLang = 'en';
  }
  setCurrentLang(newLang);
  
  if (window.SEARCH_UTILS && window.SEARCH_UTILS.saveLanguage) {
    window.SEARCH_UTILS.saveLanguage(newLang);
  }
  
  switchLanguageTab(newLang);
  updateInterfaceTexts(newLang);
  
  var searchInput = document.getElementById('search');
  if (searchInput) {
    searchInput.value = searchTerm || '';
  }
  
  var queryParts = [];
  if (searchTerm) {
    queryParts.push('search=' + encodeURIComponent(searchTerm));
  }
  if (searchType) {
    queryParts.push('search-type=' + encodeURIComponent(searchType));
  }
  
  var currentParams = new URLSearchParams(window.location.search);
  if (currentParams.has('debug')) {
    queryParts.push('debug=' + encodeURIComponent(currentParams.get('debug')));
  }
  
  var newUrl = '/' + newLang + '/';
  if (queryParts.length > 0) {
    newUrl += '?' + queryParts.join('&');
  }
  
  window.history.pushState({search: searchTerm, 'search-type': searchType, lang: newLang}, '', newUrl);
  
  var hasSearchTerm = searchTerm && searchTerm.trim().length > 0;
  if (hasSearchTerm) {
    if (window.SEARCH_API) {
      window.SEARCH_API.loadSearchResults(searchTerm, searchType);
    }
  } else {
    loadIntroContent(newLang);
  }
}

// Экспортируем глобально
window.SEARCH_LANGUAGE = {
  updateInterfaceTexts: updateInterfaceTexts,
  switchLanguageTab: switchLanguageTab,
  detectLanguageFromSearch: detectLanguageFromSearch,
  loadIntroContent: loadIntroContent,
  switchLanguage: switchLanguage,
  getCurrentLang: getCurrentLang,
  setCurrentLang: setCurrentLang,
  getSuggestedLanguage: getSuggestedLanguage
};
